import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { API_ENDPOINTS, buildApiUrl } from '../config/apiConfig';
import './AuthPage.css';

const ForgotPasswordPage = () => {
  const { isRTL } = useLanguage();
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [debugResetLink, setDebugResetLink] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) setErrors((prev) => ({ ...prev, email: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!email.trim()) {
      newErrors.email = 'الرجاء إدخال البريد الإلكتروني';
    } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
      newErrors.email = 'البريد الإلكتروني غير صالح';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setSubmitSuccess(false);
    setDebugResetLink('');
    if (!validateForm()) return;

    setIsLoading(true);
    const url = buildApiUrl(API_ENDPOINTS.FORGOT_PASSWORD);
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const contentType = res.headers.get('content-type');
      const isJson = contentType && contentType.toLowerCase().includes('application/json');
      let data = { success: false, message: '' };

      if (isJson) {
        try {
          data = await res.json();
        } catch (_) {
          setSubmitError('استجابة غير صالحة من الخادم.');
          return;
        }
      } else {
        const text = await res.text();
        if (res.status === 404 || (text && text.trim().startsWith('<'))) {
          setSubmitError('الخادم غير متاح أو المسار غير صحيح. شغّل الباكند: npm run server (يعمل على المنفذ 8080).');
        } else {
          setSubmitError('حدث خطأ من الخادم. الرجاء المحاولة لاحقاً.');
        }
        return;
      }

      if (!res.ok || !data.success) {
        throw new Error(data.message || 'حدث خطأ. الرجاء المحاولة لاحقاً.');
      }

      setSubmitSuccess(true);
      if (data.debugResetLink) {
        setDebugResetLink(data.debugResetLink);
        console.log('Reset link (dev):', data.debugResetLink);
      }
    } catch (err) {
      setSubmitError(err.message || 'حدث خطأ. الرجاء المحاولة لاحقاً.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className={`auth-page ${isRTL ? 'rtl' : ''}`}>
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">نسيت كلمة المرور؟</h1>
            <p className="auth-subtitle">
              أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور
            </p>
          </div>

          <div className="auth-form-container">
            {submitError && <div className="auth-error-box">{submitError}</div>}
            {submitSuccess && (
              <div className="auth-error-box" style={{ background: '#ecfdf3', borderColor: '#bbf7d0', color: '#166534' }}>
                إذا كان البريد مسجلًا لدينا فسيتم إرسال رابط إعادة التعيين. تحقق من بريدك أو من الـ console في وضع التطوير.
              </div>
            )}
            {debugResetLink && (
              <div className="auth-error-box" style={{ background: '#eff6ff', borderColor: '#bfdbfe', color: '#1e40af', fontSize: '0.8rem', wordBreak: 'break-all' }}>
                <strong>وضع التطوير:</strong> استخدم هذا الرابط: <a href={debugResetLink}>{debugResetLink}</a>
              </div>
            )}

            {!submitSuccess && (
              <form onSubmit={handleSubmit} className="auth-form">
                <div className="auth-input-group">
                  <label htmlFor="email" className="auth-label">البريد الإلكتروني *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className={`auth-input ${errors.email ? 'auth-input-error' : ''}`}
                    value={email}
                    onChange={handleChange}
                    placeholder="example@email.com"
                    autoComplete="email"
                  />
                  {errors.email && <div className="auth-error">{errors.email}</div>}
                </div>
                <button type="submit" className="auth-button" disabled={isLoading}>
                  {isLoading ? 'جاري الإرسال...' : 'إرسال رابط إعادة التعيين'}
                </button>
              </form>
            )}

            <div className="auth-footer" style={{ marginTop: '1.5rem' }}>
              <p className="auth-footer-text">
                <Link to="/login" className="auth-link-button">العودة لتسجيل الدخول</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPasswordPage;
